import React, { useState, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/* Плавное появление контента при переходе между разделами.
   Важно: прокрутку сбрасываем в useLayoutEffect — ДО отрисовки. В useEffect
   это происходило уже после первого кадра, и новый раздел успевал мелькнуть
   на старой позиции прокрутки — со стороны выглядело как рывок карточек. */
export default function PageTransition({ children }) {
  const location = useLocation();
  const [shown, setShown] = useState(false);

  useLayoutEffect(() => {
    setShown(false);
    window.scrollTo(0, 0);
    document.querySelectorAll('.student-main, .main-content').forEach(el => { el.scrollTop = 0; });
    // Проявление запускаем на следующем кадре, без лишнего таймера:
    // так контент не висит невидимым дольше одного кадра.
    const id = requestAnimationFrame(() => setShown(true));
    return () => cancelAnimationFrame(id);
  }, [location.pathname]);

  return <div className={'view-fade' + (shown ? ' in' : '')}>{children}</div>;
}
